import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaPaperPlane, FaCheckCircle, FaFacebook, FaSnapchat, FaTiktok, FaInstagram } from 'react-icons/fa';
import mainService from '../services/mainService';
import { useToast } from '../contexts/ToastContext';
import './Contact.css';

const Contact = () => {
  const { showToast } = useToast();
  const [formData, setFormData] = useState({
    Name: '',
    Email: '',
    MobileNo: '',
    Subject: '',
    Description: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Call the addEnquiry API
      await mainService.addEnquiry(formData);

      setIsSubmitting(false);
      setIsSubmitted(true);

      // Reset form after 3 seconds
      setTimeout(() => {
        setIsSubmitted(false);
        setFormData({
          Name: '',
          Email: '',
          MobileNo: '',
          Subject: '',
          Description: ''
        });
      }, 3000);
    } catch (error) {
      console.error('Error submitting enquiry:', error);
      setIsSubmitting(false);
      showToast('Failed to send message. Please try again.', 'error');
    }
  };

  const contactInfo = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Address",
      details: "Dubai- United Arab Emirates",

    },
    {
      icon: <FaPhone />,
      title: "Phone",
      details: "0501231234",

    },
    {
      icon: <FaEnvelope />,
      title: "Email",
      details: "info@byeilir.com",

    },

  ];

  return (
    <div className="contact-page">
      <div className="container">
        {/* Page Header */}
        <div className="page-header">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">Get in touch with our team. We'd love to hear from you.</p>
        </div>

        <div className="contact-content">
          {/* Contact Information */}
          <div className="contact-info-section">
            <h2 className="section-title">Get in Touch</h2>
            <p className="section-description">
              Have questions about our products or services? We're here to help you find the perfect solution.
            </p>

            <div className="contact-info-grid">
              {contactInfo.map((info, index) => (
                <div key={index} className="contact-info-card">
                  <div className="info-icon">
                    {info.icon}
                  </div>
                  <div className="info-content">
                    <h3 className="info-title">{info.title}</h3>
                    {info.title === "Email" ? (
                      <a href={`mailto:${info.details}`} className="info-details clickable">
                        {info.details}
                      </a>
                    ) : info.title === "Phone" ? (
                      <a href={`tel:${info.details.replace(/\s*\|\|\s*/g, '')}`} className="info-details clickable">
                        {info.details}
                      </a>
                    ) : (
                      <p className="info-details">{info.details}</p>
                    )}
                    <span className="info-subtitle">{info.subtitle}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Social Media */}
            <div className="social-section">
              <h3>Follow Us</h3>
              <div className="social-links">
                <a href="https://www.instagram.com/by.eilir/?igsh=b2l4aHh5Z2JwYmJn#" className="social-link">
                  <FaFacebook />
                </a>
                <a href="https://www.instagram.com/by.eilir/?igsh=b2l4aHh5Z2JwYmJn#" className="social-link">
                  <FaSnapchat />
                </a>
                <a href="https://www.instagram.com/by.eilir/?igsh=b2l4aHh5Z2JwYmJn#" className="social-link">
                  <FaTiktok />
                </a>
                <a href="https://www.instagram.com/by.eilir/?igsh=b2l4aHh5Z2JwYmJn#" className="social-link">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-section">
            <h2 className="section-title">Send us a Message</h2>

            {isSubmitted ? (
              <div className="success-message">
                <FaCheckCircle className="success-icon" />
                <h3>Message Sent Successfully!</h3>
                <p>Thank you for contacting us. We'll get back to you within 24 hours.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="Name">Full Name *</label>
                    <input
                      type="text"
                      id="Name"
                      name="Name"
                      value={formData.Name}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="Email">Email Address *</label>
                    <input
                      type="email"
                      id="Email"
                      name="Email"
                      value={formData.Email}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="MobileNo">Phone Number</label>
                    <input
                      type="tel"
                      id="MobileNo"
                      name="MobileNo"
                      value={formData.MobileNo}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="+971 50 123 4567"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="Subject">Subject *</label>
                    <input
                      type="text"
                      id="Subject"
                      name="Subject"
                      value={formData.Subject}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter your subject"
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="Description">Message *</label>
                  <textarea
                    id="Description"
                    name="Description"
                    value={formData.Description}
                    onChange={handleChange}
                    className="form-control"
                    rows="6"
                    placeholder="Tell us how we can help you..."
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <div className="spinner"></div>
                      Sending...
                    </>
                  ) : (
                    <>
                      <FaPaperPlane />
                      Send Message
                    </>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>


      </div>
    </div>
  );
};

export default Contact;
